import { h } from 'preact';
import { useState } from 'preact/hooks';
import ColumnInnerContentSwiper from './column-inner-content-swiper';
import globalAddToCart from '../cart/global-add-to-cart';

const ColumnInnerContent = ({ data, setCurrentMediaItem }) => {
  const {
    title: columnInnerTitle,
    description,
    buyButtonBg,
    buyButtonText,
    productsList,
    ctaLinkUrl
  } = data

  const [currentItem, setCurrentItem] = useState({ ...productsList[0] });
  const handleItemChange = (id) => {
    const compareFn = ({ variant_id: variantId }) =>
      Number(variantId) === Number(id);
    const item = productsList.find((i) => compareFn(i));
    setCurrentItem(item);
    setCurrentMediaItem(productsList.findIndex((i) => compareFn(i)));
  };
  const handleClick = () => {
    const { handle, variant_id: variantId } = currentItem
    globalAddToCart({
      handle,
      variantId,
      quantity: 1
    })
  }

  const contentTitle = () => <p className='v-h4'>{columnInnerTitle}</p>
  const contentDescription = () => <p className='v-paragraph my-[10px]'>{description}</p>
  // eslint-disable-next-line no-script-url
  const noLinkFn = 'javascript:void(0)';

  return (
    <column-inner-content-container className='flex flex-col justify-between w-full'>
      <column-inner-content-top className='flex flex-col align-center pt-[40px] px-[20px] laptop:p-[50px] laptop:pb-0'>
        {contentTitle()}
        {contentDescription()}
        {productsList.length > 0 ? (
          <ColumnInnerContentSwiper
            productsList={productsList}
            handleItemChange={handleItemChange}
          />
        ) : null}
      </column-inner-content-top>
      <column-inner-content-buttons className='flex h-[52px]'>
        <button
          className='flex justify-center items-center flex-1 v-cta-small uppercase'
          onClick={handleClick}
          style={`background-color: ${buyButtonBg}`}>{buyButtonText}</button>
        <a href={ctaLinkUrl || noLinkFn }
          className='flex justify-center items-center flex-1 v-cta-small uppercase border-[1px] border-black-30 hover:[background-size:0_0]'>
          explore collection
        </a>
      </column-inner-content-buttons>
    </column-inner-content-container>
  );

};

export default ColumnInnerContent;